import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import * as moment from 'moment'
import { requestAddSingleClientNote } from '../../../../../../../redux/actions/single-client'
import { auth } from '../../../../../../../networking/firebase'
import { Input } from '../../../../../../library/input'
import './style.scss'

const Index = props => {

	const dispatch = useDispatch()
	const [noteContent, setNoteContent] = useState("");

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)


	const clickAddNote = () => {

		const singleNote = {content: noteContent, timestamp: moment(Date.now()).unix(), author: auth.currentUser.uid};
		dispatch(requestAddSingleClientNote({companyId: selectedCompany, user: auth.currentUser.uid, id: props.match.params.id, note: singleNote}))
		setNoteContent("")

	}

	const handleEnterClick = e => {
		if(e.key === 'Enter'){
			clickAddNote()
		}
	}

	return(
			<Row className="compose-note-container">
				<Col className="input-col">
					<Input onKeyDown={handleEnterClick} onChange={(e) => setNoteContent(e.target.value)} placeholder="Skriv inn notat" value={noteContent} type="text"/>
				</Col>
				<Col className="button-col text-right">
					<button onClick={clickAddNote} className="send-button"><i class="fas fa-paper-plane"></i></button>
				</Col>
			</Row>
	)
}

export default withRouter(Index)


